<div class="row top-padding">
  <div class="ten columns">
    <div class="row">

      <div *ngIf = "interval === 'DAILY'; then dailyBlock else weeklyOrMonthlyBlock"></div>

      <ng-template #dailyBlock>
        <div class="field" data-automation-id="lm-period-override-daily-field">
          <label soho-label for="currPeriod">{{labelPeriod}}</label>
          <input
          id = "currPeriod"
          soho-datepicker [options]="pickerOptions" mode="standard"
          soho-trackdirty (pristine)="onPristine($event)" (dirty)="onDirty($event)"
          [(ngModel)] = "date"
          />
        </div>
      </ng-template>

      <ng-template #weeklyOrMonthlyBlock>
        <div class="field" data-automation-id="lm-period-override-current-period-field">
          <label soho-label for="currPeriod2">{{labelPeriod}}</label>
          <input id="currPeriod2" readonly [value]="currPeriodKey"/>
        </div>
        <div class="field" data-automation-id="lm-period-override-year">
          <label soho-label for="year">{{labelYear}}</label>
          <!-- soho-spin box doesn't have an attributes input. So instead attributes is
               being placed on the data-options attribute. That will then get picked up by
               spinbox.js in ids-enterprise.
           -->
          <input soho-spinbox id="year" name="year"
            soho-trackdirty (pristine)="onPristine($event)" (dirty)="onDirty($event)"
            attr.data-options="{{yearOptions}}"
          [(ngModel)]="year"/>
        </div>
        <div class="field" data-automation-id="lm-period-override-week-month-slider">
          <label soho-label for="slider-period">{{sliderPeriodLabel}}</label>
          <input soho-slider id="slider-period"
              [attributes]="periodAttributes"
              [min]="sliderMin" [max]="sliderMax" step="1" [value]="sliderPeriodValue"
              tooltipContent="" persistTooltip="true"
              (change)="onSliderPeriodUpdated($event)"
          />
        </div>
      </ng-template>

    </div>
  </div>
</div>
